import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminAddStandardFeePage = React.lazy(() => import(/* webpackChunkName: "AdminAddStandardFee" */ './Page'));
export const AdminAddStandardFee = () => (React.createElement(Page, { title: "Administrator Add Standard Fee" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AdminAddStandardFeePage, null)))));
